export class NavigateWrapper {
    static navigate;
    static init(navigate) {
        NavigateWrapper.navigate = navigate;
    }
}
